// fr法语
export default {
    CustomSelect: {
        '请选择': 'Sélectionner',
    },
    TopNav: {
        '创作者': 'Créateur',
        '游客': 'Visiteur',
        '请登录后体验完整功能': 'Veuillez vous connecter pour profiter de toutes les fonctionnalités',
        '登录': 'Se connecter',
        '免费试用': 'Essai gratuit',
        '退出登录': 'Se déconnecter',
        '个人中心': 'Mon compte',
        '我的视频': 'Mes vidéos',
        '额度管理': 'Gestion du crédit',
        '首页': 'Accueil',
        'AI创作': 'Création IA',
        '多参考': 'Multi-référence',
        '文本视频': 'Texte vers vidéo',
        '图片视频': 'Image vers vidéo',
        '文生图': 'Texte vers image',
        '图生图': 'Image vers image',
        '会员中心': 'Espace membre',
        '概览': 'Aperçu',
        '我的创作': 'Mes créations',
        '账单管理': 'Gestion des factures',
        '生成任务': 'Tâches de génération',
        '价格': 'Tarifs',
        '新闻资讯': 'Actualités',
        '确定要退出登录吗？': 'Voulez-vous vous déconnecter ?',
        '提示': 'Astuce',
        '确定': 'Confirmer',
        '取消': 'Annuler',
        '退出成功': 'Déconnexion réussie',
        '视频展示': 'Présentation vidéo'
    },
    AiLayout: {
        'AI创作中心': 'Centre de création IA',
        '视频生成': 'Génération vidéo',
        '图片生成': 'Génération image',
        '我的作品': 'Mes œuvres',
        '我的创作': 'Mes créations',
        '今日剩余额度': 'Crédit restant aujourd\'hui',
        '多参考': 'Multi-référence',
        '文本视频': 'Texte vers vidéo',
        '图片视频': 'Image vers vidéo',
        '文生图': 'Texte vers image',
        '图生图': 'Image vers image',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Plateforme de nouvelle génération pour la génération vidéo IA, transformez vos idées en réalité instantanément',
        '产品': 'Produits',
        'AI视频': 'Vidéo IA',
        '价格方案': 'Formules tarifaires',
        '新闻资讯': 'Actualités',
        '支持': 'Support',
        '帮助中心': 'Centre d\'aide',
        'API文档': 'Documentation API',
        '常见问题': 'FAQ',
        '法律': 'Juridique',
        '服务条款': 'Conditions d\'utilisation',
        '隐私政策': 'Politique de confidentialité',
        '使用协议': 'Accord d\'utilisation',
        '版权所有': 'Tous droits réservés',
        '客服邮箱': 'Email support',
        '复制邮箱': 'Copier l\'email',
        '开发中': 'En développement, restez à l\'écoute !',
        '链接已复制到剪贴板': 'Lien copié dans le presse-papiers',
    },
    MyLayout: {
        '创作者': 'Créateur',
        '退出登录': 'Se déconnecter',
        '概览': 'Aperçu',
        '我的创作': 'Mes créations',
        '会员中心': 'Espace membre',
        '额度管理': 'Gestion du crédit',
        '账单管理': 'Gestion des factures',
        '生成任务': 'Tâches de génération',
        '确定要退出登录吗？': 'Voulez-vous vous déconnecter ?',
        '提示': 'Astuce',
        '确定': 'Confirmer',
        '取消': 'Annuler',
        '退出成功': 'Déconnexion réussie'
    },
    Image: {
        "文本生成图片": "Texte vers image",
        "图片生成图片": "Image vers image",
        "用文字描述": "Décrivez avec des mots ce que vous souhaitez",
        "上传图片素材": "Téléchargez des images, prend en charge la génération multiple",
        "图片描述": "Description de l'image",
        "描述您想要的图片": "Décrivez en détail le contenu de l'image souhaitée, en français ou en anglais...",
        "提示描述越详细效果越好": "Astuce : Plus la description est détaillée, meilleur est le résultat",
        "图片素材": "Matériel image",
        "预览图片": "Aperçu",
        "上传图片": "Télécharger l'image",
        "支持格式JPGPNG": "Prend en charge les formats JPG, PNG",
        "最多": "Maximum",
        "张图片": "image(s)",
        "超过大小限制": "Dépasse la limite de 10 Mo",
        "不是图片文件": "Fichier image non valide",
        "最多上传": "Téléchargement maximum",
        "请先上传图片": "Veuillez d'abord télécharger des images",
        "请选择要生成的图片": "Veuillez sélectionner l'image à générer",
        "生成结果": "Résultat de la génération",
        "重新生成成功": "Régénération réussie",
        "模型": "Modèle IA",
        "请选择模型": "Veuillez sélectionner le modèle",
        "分辨率": "Résolution de sortie",
        "请选择分辨率": "Veuillez sélectionner la résolution",
        "图片比例": "Rapport d'aspect",
        "补充描述": "Description supplémentaire (optionnel)",
        "补充描述提示": "Optionnel : décrivez les effets ou styles supplémentaires que vous souhaitez pour l'image",
        "开始绘制": "Commencer le dessin",
        "开始生成": "Commencer la génération",
        "生成中": "Génération en cours, veuillez patienter...",
        "生成成功": "Génération réussie",
        "图片生成成功": "Image générée avec succès !",
        "作品已保存到我的作品": "L'œuvre a été sauvegardée dans « Mes œuvres »",
        "继续创作": "Continuer à créer",
        "查看作品": "Voir l'œuvre",
        "请输入图片描述": "Veuillez entrer une description de l'image"
    },
    MyCreation: {
        '我的创作': 'Mes créations',
        '查看和管理您的所有作品': 'Affichez et gérez toutes vos œuvres',
        '预览': 'Aperçu',
        '下载': 'Télécharger',
        '编辑': 'Modifier',
        '分享': 'Partager',
        '删除': 'Supprimer',
        '暂无作品': 'Aucune œuvre',
        '去创作': 'Créer',
        '确定删除': 'Confirmer la suppression',
        '确定要删除作品': 'Voulez-vous supprimer l\'œuvre',
        '吗？': ' ?',
        '此操作不可恢复': 'Cette action est irréversible, soyez prudent !',
        '取消': 'Annuler',
        '分享作品': 'Partager l\'œuvre',
        '复制链接': 'Copier le lien',
        '全部': 'Tout',
        '视频': 'Vidéo',
        '图片': 'Image',
        '正在下载:': 'Téléchargement : ',
        '链接已复制到剪贴板': 'Lien copié dans le presse-papiers',
        '删除成功': 'Suppression réussie'
    },
    Video: {
        "文本生成视频": "Texte vers vidéo",
        "图片生成视频": "Image vers vidéo",
        "智能视频生成": "Génération vidéo intelligente",
        "输入文字描述": "Entrez une description textuelle",
        "上传1-9张图片": "Téléchargez 1 à 9 images",
        "上传图片视频音频": "Téléchargez image/vidéo/audio",
        "视频描述": "Description de la vidéo",
        "描述您想要的视频场景": "Décrivez la scène vidéo souhaitée",
        "提示": "Astuce",
        "图片素材": "Matériel image",
        "最多上传": "Téléchargement maximum",
        "张": "image(s)",
        "预览": "Aperçu",
        "上传图片": "Télécharger l'image",
        "支持格式": "Formats JPG, PNG, taille max par fichier 10 Mo, maximum",
        "AI": "L'IA intègre intelligemment et produira des transitions fluides",
        "动态描述": "Description du mouvement",
        "描述您希望图片如何动起来": "Décrivez comment vous voulez que l'image s'anime",
        "个": "élément(s)",
        "上传视频": "Télécharger la vidéo",
        "上传音频": "Télécharger l'audio",
        "描述您希望视频呈现的效果": "Décrivez l'effet souhaité pour la vidéo",
        "模型": "Modèle",
        "请选择模型": "Veuillez sélectionner le modèle",
        "分辨率": "Résolution",
        "请选择分辨率": "Veuillez sélectionner la résolution",
        "宽高比": "Rapport d'aspect",
        "视频时长": "Durée de la vidéo",
        "生成音频": "Générer l'audio",
        "开启音效": "Activer les effets sonores",
        "静音模式": "Mode silencieux",
        "音频提示": "Astuce : L'audio téléchargé sera utilisé comme musique de fond. Si aucun audio n'est téléchargé, l'IA générera automatiquement la musique",
        "开始生成": "Commencer la génération",
        "积分": "Crédits",
        "生成中": "Génération en cours",
        "生成成功": "Génération réussie",
        "视频生成成功！": "Vidéo générée avec succès !",
        "作品已保存到": "L'œuvre a été sauvegardée dans « Mes œuvres »",
        "继续创作": "Continuer à créer",
        "查看作品": "Voir l'œuvre",
        "视频预览": "Aperçu vidéo",
        "关闭": "Fermer",
        "下载视频": "Télécharger la vidéo",
        "您的浏览器不支持视频播放": "Votre navigateur ne prend pas en charge la lecture vidéo",
        "生成进度": "Progression de la génération",
        "描述": "Description",
        "时长": "Durée",
        "秒": "secondes",
        "视频素材": "Matériel vidéo",
        "音频素材": "Matériel audio",
        "双图融合模式": "Mode fusion double image",
        "开始下载视频": "Commencer le téléchargement de la vidéo",
        "请输入视频描述": "Veuillez entrer une description de la vidéo",
        "请至少上传一张图片": "Veuillez télécharger au moins une image",
        "请至少上传一张图片或一个视频": "Veuillez télécharger au moins une image ou une vidéo",
        "最多只能上传": "Téléchargement maximum",
        "超过": "Dépasse",
        "限制": "la limite",
        "不是图片文件": "Fichier image non valide",
        "不是视频文件": "Fichier vidéo non valide",
        "不是音频文件": "Fichier audio non valide"
    },
    Forgot: {
        "找回密码": "Récupérer le mot de passe",
        "请输入您的邮箱，我们将发送验证码": "Veuillez entrer votre email, nous enverrons un code de vérification",
        "密码重置成功，请使用新密码登录": "Réinitialisation réussie, veuillez vous connecter avec le nouveau mot de passe",
        "密码重置成功": "Réinitialisation réussie",
        "您的密码已成功重置，请使用新密码登录": "Votre mot de passe a été réinitialisé avec succès, veuillez vous connecter avec votre nouveau mot de passe",
        "立即登录": "Se connecter maintenant",
        "邮箱": "Email",
        "请输入注册邮箱": "Veuillez entrer l'email d'inscription",
        "发送验证码": "Envoyer le code",
        "请输入验证码": "Veuillez entrer le code de vérification",
        "验证码": "Code de vérification",
        "新密码": "Nouveau mot de passe",
        "设置新密码": "Définir un nouveau mot de passe",
        "确认新密码": "Confirmer le nouveau mot de passe",
        "再次输入新密码": "Entrez à nouveau le nouveau mot de passe",
        "重置密码": "Réinitialiser le mot de passe",
        "返回登录": "Retour à la connexion",
        "验证中": "Vérification en cours",
        "重置中": "Réinitialisation en cours",
        "弱": "Faible",
        "中": "Moyen",
        "强": "Fort",
        "请输入邮箱地址": "Veuillez entrer l'adresse email",
        "请输入正确的邮箱格式": "Veuillez entrer un format d'email valide",
        "验证码应为6位数字": "Le code de vérification doit comporter 6 chiffres",
        "请输入新密码": "Veuillez entrer un nouveau mot de passe",
        "密码至少需要6位": "Le mot de passe doit comporter au moins 6 caractères",
        "请再次输入新密码": "Veuillez entrer à nouveau le nouveau mot de passe",
        "两次输入的密码不一致": "Les mots de passe saisis ne correspondent pas",
        "验证码已发送": "Code de vérification envoyé"
    },
    Login: {
        "下一代AI视频生成平台": "Plateforme de nouvelle génération pour la génération vidéo IA",
        "一键生成": "Génération en un clic",
        "支持4K超高清输出": "Sortie 4K ultra haute définition",
        "多种风格模板任选": "Choisissez parmi de nombreux modèles de styles",
        "商用授权无忧使用": "Licence commerciale pour une utilisation sans souci",
        "欢迎回来": "Bon retour",
        "登录您的账号继续创作": "Connectez-vous pour continuer à créer",
        "邮箱": "Email",
        "请输入邮箱地址": "Veuillez entrer l'adresse email",
        "密码": "Mot de passe",
        "请输入您的密码": "Veuillez entrer votre mot de passe",
        "记住我": "Se souvenir de moi",
        "忘记密码？": "Mot de passe oublié ?",
        "登录": "Se connecter",
        "登录中": "Connexion en cours",
        "还没有账号？": "Pas encore de compte ?",
        "立即注册": "S'inscrire maintenant",
        "请输入正确的邮箱格式": "Veuillez entrer un format d'email valide",
        "请输入密码": "Veuillez entrer le mot de passe",
        "密码至少需要6位": "Le mot de passe doit comporter au moins 6 caractères",
        "密码不能超过20位": "Le mot de passe ne peut pas dépasser 20 caractères",
        "登录成功": "Connexion réussie"
    },
    Register: {
        "创建账号": "Créer un compte",
        "开始您的AI视频创作之旅": "Commencez votre aventure de création vidéo IA",
        "姓名": "Nom",
        "请输入您的姓名": "Veuillez entrer votre nom",
        "邮箱": "Email",
        "请输入邮箱地址": "Veuillez entrer l'adresse email",
        "获取验证码": "Obtenir le code de vérification",
        "验证码": "Code de vérification",
        "请输入验证码": "Veuillez entrer le code de vérification",
        "密码": "Mot de passe",
        "设置密码": "Définir le mot de passe",
        "确认密码": "Confirmer le mot de passe",
        "再次输入密码": "Entrez à nouveau le mot de passe",
        "我已阅读并同意": "J'ai lu et j'accepte",
        "服务条款": "les conditions d'utilisation",
        "和": "et",
        "隐私政策": "la politique de confidentialité",
        "注册中": "Inscription en cours",
        "已有账号？": "Déjà un compte ?",
        "立即登录": "Se connecter maintenant",
        "弱": "Faible",
        "中": "Moyen",
        "强": "Fort",
        "请输入姓名": "Veuillez entrer le nom",
        "姓名至少需要2个字符": "Le nom doit comporter au moins 2 caractères",
        "姓名不能超过20个字符": "Le nom ne peut pas dépasser 20 caractères",
        "请输入正确的邮箱格式": "Veuillez entrer un format d'email valide",
        "验证码应为6位数字": "Le code de vérification doit comporter 6 chiffres",
        "请输入密码": "Veuillez entrer le mot de passe",
        "密码至少需要6位": "Le mot de passe doit comporter au moins 6 caractères",
        "密码不能超过20位": "Le mot de passe ne peut pas dépasser 20 caractères",
        "请再次输入密码": "Veuillez confirmer le mot de passe",
        "两次输入的密码不一致": "Les mots de passe ne correspondent pas",
        "验证码已发送": "Code de vérification envoyé",
        "注册成功": "Inscription réussie"
    },
    Faq: {
        '常见问题': 'Foire aux questions',
        '您在使用过程中遇到的问题': 'Les problèmes que vous rencontrez lors de l\'utilisation, trouvez les réponses ici',
        '搜索您的问题': 'Recherchez votre question...',
        '没有找到相关的问题': 'Aucune question trouvée',
        '查看全部问题': 'Voir toutes les questions',
        '没有找到您想要的答案？': 'Vous n\'avez pas trouvé la réponse que vous cherchez ?',
        '我们的客服团队随时为您提供帮助': 'Notre équipe de support est disponible pour vous aider',
        '复制客服邮箱': 'Copier l\'email du support',
        '链接已复制到剪贴板': 'Lien copié dans le presse-papiers'
    },
    Home: {
        '立即订阅': 'Abonnez-vous maintenant ',
        'AI视频生成新时代': 'Nouvelle ère de la génération vidéo IA',
        '用文字创造': 'Créez avec des mots',
        '无限视频': 'Vidéos illimitées',
        '让每个人都能成为视频创作者': 'Permettez à chacun de devenir créateur de vidéos. Il suffit d\'entrer une description textuelle pour obtenir des vidéos IA de haute qualité et uniques.',
        '免费开始': 'Commencer gratuitement',
        '观看演示': 'Voir la démo',
        'AI生成': 'Génération IA',
        'AI视频': 'Vidéo IA',
        '三步轻松生成专业视频': 'Trois étapes simples pour générer des vidéos professionnelles',
        '输入提示词': 'Entrez une instruction',
        '用文字描述您想要的视频内容': 'Décrivez avec des mots le contenu vidéo souhaité, plus c\'est détaillé, meilleur est le résultat',
        '智能生成': 'Génération intelligente',
        'AI模型自动理解并创作': 'Le modèle IA comprend et crée automatiquement, le rendu est terminé en quelques minutes',
        '下载作品': 'Télécharger l\'œuvre',
        '高清视频生成完成': 'Vidéo HD générée, prête à être téléchargée et utilisée immédiatement',
        'AI视频生成': 'Génération vidéo IA',
        '精彩视频': 'Entrez une description textuelle, l\'IA générera une vidéo exceptionnelle pour vous',
        '描述您想要的视频场景': 'Décrivez la scène vidéo souhaitée, par exemple : Un chat jouant sous un cerisier en fleurs, la lumière du soleil traversant les pétales...',
        '生成中': 'Génération en cours...',
        '生成视频': 'Générer la vidéo',
        'AI图片': 'Image IA',
        '精美图片': 'Entrez une description textuelle, l\'IA générera une image exceptionnelle pour vous',
        '描述您想要的图片场景': 'Décrivez la scène d\'image souhaitée, par exemple : Ciel d\'une ville futuriste, lumières néon scintillantes, style cyberpunk...',
        '生成图片': 'Générer l\'image',
        '强大功能': 'Fonctionnalités puissantes',
        '让视频创作变得简单有趣': 'Rendez la création vidéo simple et amusante',
        '案例展示': 'Exemples',
        '来看看用户使用': 'Venez voir les œuvres exceptionnelles créées par les',
        '创作的精彩作品': 'utilisateurs',
        '新闻资讯': 'Actualités',
        '了解': 'Découvrez les',
        '的最新动态和产品更新': 'dernières actualités et mises à jour produits',
        '查看更多': 'Voir plus',
        '热门': 'Populaire',
        '最新': 'Récent',
        '阅读更多': 'Lire la suite',
        '选择适合您的方案': 'Choisissez la formule qui vous convient',
        '灵活的定价': 'Tarifs flexibles pour différents besoins',
        '视频预览': 'Aperçu vidéo',
        '生成成功': 'Génération réussie',
        '作品已保存到': 'L\'œuvre a été sauvegardée dans « Mes créations »',
        '继续创作': 'Continuer à créer',
        '查看作品': 'Voir l\'œuvre',
        '请输入视频描述': 'Veuillez entrer une description de la vidéo',
        '视频生成成功！': 'Vidéo générée avec succès !',
        '请输入图片描述': 'Veuillez entrer une description de l\'image',
        '图片生成成功！': 'Image générée avec succès !',
    },
    News: {
        '新闻资讯': 'Actualités',
        '了解': 'Découvrez les',
        '的最新动态和产品更新': 'dernières actualités et mises à jour produits',
        '精选': 'À la une',
        '阅读': 'Lire',
        '点赞': 'J\'aime',
        '热门': 'Populaire',
        '最新': 'Récent',
        '阅读更多': 'Lire la suite',
        '加载中': 'Chargement...',
        '暂无新闻': 'Aucune actualité',
        '清除筛选': 'Effacer les filtres',
        '加载新闻失败': 'Échec du chargement des actualités, veuillez réessayer plus tard',
    },
    Price: {
        '选择适合您的方案': 'Choisissez la formule qui vous convient',
        '灵活的定价': 'Tarifs flexibles pour différents besoins',
        '包月': 'Mensuel',
        '包年': 'Annuel',
        '购买积分': 'Acheter des crédits',
        '只需要几个视频': 'Vous n\'avez besoin que de quelques vidéos ? Pas d\'abonnement, achetez directement un pack de crédits',
        '产品大全': 'Catalogue des produits',
        '了解': 'Découvrez',
        '全系列产品的详细信息和支付方式': 'les informations détaillées et les méthodes de paiement pour toute la gamme de produits'
    },
    Billing: {
        '账单管理': 'Gestion des factures',
        '账户余额': 'Solde du compte',
        '本月支出': 'Dépenses du mois',
        '订单数量': 'Nombre de commandes',
        '账单列表': 'Liste des factures',
        '请选择类型': 'Veuillez sélectionner le type',
        '请选择时间范围': 'Veuillez sélectionner la plage de temps',
        '订单号': 'Numéro de commande',
        '类型': 'Type',
        '金额': 'Montant',
        '状态': 'Statut',
        '时间': 'Date',
        '操作': 'Action',
        '查看详情': 'Voir les détails',
        '下载发票': 'Télécharger la facture',
        '暂无作品': 'Aucune œuvre',
        '去创作': 'Créer',
        '支付方式': 'Moyen de paiement',
        '添加支付方式': 'Ajouter un moyen de paiement',
        '默认': 'Défaut',
        '设为默认': 'Définir par défaut',
        '编辑': 'Modifier',
        '删除': 'Supprimer',
        '账单详情': 'Détails de la facture',
        '交易流水号': 'Numéro de transaction',
        '关闭': 'Fermer',
        '账号': 'Compte/Numéro de carte',
        '请输入账号或卡号': 'Veuillez entrer le numéro de compte ou de carte',
        '姓名': 'Nom',
        '请输入持卡人姓名': 'Veuillez entrer le nom du titulaire',
        '有效期': 'Date d\'expiration',
        '请输入CVV码': 'Veuillez entrer le code CVV',
        '取消': 'Annuler',
        '确认添加': 'Confirmer l\'ajout',
        '确认修改': 'Confirmer la modification',
        '确认删除': 'Confirmer la suppression',
        '编辑支付方式': 'Modifier le moyen de paiement',
        '确定要删除支付方式': 'Voulez-vous supprimer ce moyen de paiement',
        '删除后不可恢复': 'La suppression est irréversible, soyez prudent !',
        '请输入账号': 'Veuillez entrer le numéro de compte/carte',
        '添加成功': 'Ajout réussi',
        '修改成功': 'Modification réussie',
        '已设为默认支付方式': 'Défini comme moyen de paiement par défaut',
        '删除成功': 'Suppression réussie',
    },
    Credit: {
        '额度管理': 'Gestion du crédit',
        '当前可用额度': 'Crédit disponible actuellement',
        '升级会员': 'Améliorer l\'abonnement',
        '本月已用': 'Utilisé ce mois-ci',
        '视频生成': 'Génération vidéo',
        'AI图片': 'Image IA',
        '其他': 'Autres',
        '购买额度包': 'Acheter un pack de crédits',
        '最受欢迎': 'Le plus populaire',
        '额度': 'Crédits',
        '立即购买': 'Acheter maintenant',
        '使用记录': 'Historique d\'utilisation',
        '操作': 'Action',
        '类型': 'Type',
        '额度变动': 'Changement de crédit',
        '时间': 'Date',
        '购买': 'Acheter',
        '确认购买': 'Confirmer l\'achat',
        '金额': 'Montant : ',
        '获得': 'Vous obtenez',
        '取消': 'Annuler',
        '今天': 'Aujourd\'hui',
        '昨天': 'Hier',
    },
    Dashboard: {
        '欢迎回来': 'Bon retour,',
        '创建新视频': 'Créer une nouvelle vidéo',
        '本月生成次数': 'Nombre de générations ce mois-ci',
        '剩余额度': 'Crédit restant',
        '总视频数': 'Nombre total de vidéos',
        '会员状态': 'Statut d\'abonnement',
        '最近生成': 'Générations récentes',
        '查看全部': 'Voir tout',
        '视频预览': 'Aperçu vidéo',
        '视频生成中': 'Génération en cours, veuillez patienter pour l\'aperçu',
    },
    Membership: {
        '会员中心': 'Espace membre',
        '当前方案': 'Forfait actuel',
        'Pro 会员': 'Pro',
        '专业创作者首选': 'Le choix idéal pour les créateurs professionnels',
        '月': 'mois',
        '会员有效期': 'Validité de l\'abonnement',
        '剩余天数': 'Jours restants',
        '续费会员': 'Renouveler l\'abonnement',
        '取消订阅': 'Annuler l\'abonnement',
        '本月使用情况': 'Utilisation ce mois-ci',
        '视频生成': 'Génération vidéo',
        '次': 'fois',
        '额度使用': 'Utilisation du crédit',
        '快速生成': 'Génération rapide',
        '升级方案': 'Améliorer le forfait',
        '联系销售': 'Contacter le service commercial',
        '会员权益': 'Avantages membres',
        '续费后将延长会员有效期30天': 'Le renouvellement prolonge l\'abonnement de 30 jours',
        '取消': 'Annuler',
        '确认续费': 'Confirmer le renouvellement',
        '取消后您将失去所有会员权益': 'Après annulation, vous perdez tous les avantages, le crédit restant est conservé',
        '再想想': 'Réfléchir',
        '确认取消': 'Confirmer l\'annulation',
        '姓名': 'Nom',
        '请输入您的姓名': 'Veuillez entrer votre nom',
        '请输入姓名': 'Veuillez entrer le nom',
        '公司': 'Société',
        '请输入公司名称': 'Veuillez entrer le nom de la société',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Veuillez entrer l\'adresse email',
        '请输入邮箱': 'Veuillez entrer l\'email',
        '请输入正确的邮箱格式': 'Veuillez entrer un format d\'email valide',
        '需求': 'Demande',
        '请描述您的需求': 'Veuillez décrire votre demande',
        '提交': 'Envoyer',
        '请填写需求': 'Veuillez décrire la demande',
        '续费成功': 'Renouvellement réussi ! L\'abonnement a été prolongé',
        '已取消订阅': 'Abonnement annulé, il expirera à la fin de la période',
        '提交成功': 'Envoyé avec succès, nous vous contacterons bientôt !',
    },
    Task: {
        '生成任务': 'Tâches de génération',
        '新建任务': 'Nouvelle tâche',
        '进行中': 'En cours',
        '已完成': 'Terminé',
        '失败': 'Échoué',
        '队列中': 'En file d\'attente',
        '活跃任务': 'Tâches actives',
        '刷新': 'Actualiser',
        '暂无活跃任务': 'Aucune tâche active',
        '预计剩余': 'Temps restant estimé',
        '暂停': 'Pause',
        '继续': 'Continuer',
        '取消': 'Annuler',
        '最近完成': 'Récemment terminées',
        '查看全部': 'Voir tout',
        '暂无完成的任务': 'Aucune tâche terminée',
        '播放': 'Lire',
        '下载': 'Télécharger',
        '分享': 'Partager',
        '确认取消': 'Confirmer l\'annulation',
        '确定要取消任务吗': 'Voulez-vous vraiment annuler la tâche ?',
        '已消耗的额度将无法退还': 'Le crédit consommé ne sera pas remboursé',
        '返回': 'Retour',
        '分享作品': 'Partager l\'œuvre',
        '复制链接': 'Copier le lien',
        '任务列表已刷新': 'Liste des tâches actualisée',
        '已暂停': 'En pause',
        '生成中': 'Génération en cours',
        '已恢复': 'Repris',
        '任务已取消': 'Tâche annulée',
        '链接已复制到剪贴板': 'Lien copié dans le presse-papiers',
    },
    VideoShow: {
        '示例': 'Exemples',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Une sélection de clips soigneusement choisis dans notre bibliothèque de démonstration. Cliquez sur n\'importe quelle carte pour commencer à générer du contenu de style similaire.',
        '全部': 'Tout',
        '电影感': 'Cinématographique',
        '角色': 'Personnages',
        '产品': 'Produits',
        '自然': 'Nature',
        '趣味': 'Ludique',
        '加载中': 'Chargement',
        '暂无展示': 'Aucune démo',
        '视频预览': 'Aperçu vidéo',
    },
    Request: {
        '加载中': 'Chargement...',
        '您已退出登录': 'Vous vous êtes déconnecté, vous pouvez vous reconnecter',
        '确认退出': 'Confirmer la déconnexion',
        '重新登录': 'Se reconnecter',
        '错误': 'Erreur',
        '网络错误': 'Erreur réseau',
        '下载中': 'Téléchargement...'
    },
    Other: {
        '剩余额度': 'Solde restant',
        '去登录': 'Se connecter',
        '请登录后查看': 'Veuillez vous connecter pour voir',
        '任务': 'Tâche',
        '可在「生成任务」中查看详情': ', vous pouvez voir les détails dans « Tâches de génération »',
        '查看详情': 'Voir les détails',
        '排队中': 'En file d\'attente',
        '运行中': 'En cours',
        '取消': 'Annuler',
        '成功': 'Succès',
        '失败': 'Échec',
        '超时': 'Délai expiré',
        '最后更新': 'Dernière mise à jour :',
        '视频生成': 'Génération de vidéo',
        '活跃用户': 'Utilisateurs actifs',
        '用户评分': 'Note des utilisateurs',
        '万': 'mille',
        '快速生成': 'Génération rapide',
        '先进的AI模型': 'Modèles d\'IA avancés générant des vidéos de haute qualité en quelques minutes',
        '多种风格': 'Styles variés',
        '多种风格任您选择': 'Réaliste, anime, artistique et plus encore à votre choix',
        '高清输出': 'Sortie haute définition',
        '支持4K超高清视频输出': 'Prend en charge la sortie vidéo 4K ultra haute définition, détails nets et clairs',
        '商用授权': 'Licence commerciale',
        '生成的视频可用于商业用途': 'Les vidéos générées peuvent être utilisées à des fins commerciales, sans souci de droits d\'auteur',
        '原价': 'Prix d\'origine',
        '积分价格说明': 'Explication des prix des crédits',
        '系列': 'Série',
        '模型': 'Modèle',
        '分辨率': 'Résolution',
        '积分': 'Crédits',
        '秒': 'seconde',
        '秒示例': 'secondes (exemple)',
        '图片模型': 'Modèle d\'image',
        '图片为': 'L\'image est',
        '系列产品': 'Produits de la série, prend actuellement en charge',
        '支持使用任意机型查看完整体验': ', prend en charge l\'utilisation de n\'importe quel appareil pour une expérience complète.',
        '计费方式': 'Mode de facturation',
        '张': 'image(s)',
        '按生成张数计费': 'Facturation basée sur le nombre d\'images générées',
        '普通用户': 'Utilisateur normal',
        '无记录': 'Aucun enregistrement',
        '总支出': 'Dépenses totales',
        '月总使用': 'Utilisation mensuelle totale',
        '月视频使用': 'Utilisation vidéo mensuelle',
        '月图片使用': 'Utilisation image mensuelle',
        '生成成功': 'Génération réussie',
        '视频总生成': 'Total de vidéos générées',
        '图片总生成': 'Total d\'images générées',
        '生成中': 'Génération en cours, veuillez patienter 1 à 3 minutes',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Une collection soigneusement sélectionnée de clips de notre bibliothèque de démonstration.',
        '最近7天': '7 derniers jours',
        '最近30天': '30 derniers jours',
        '本月': 'Ce mois-ci',
        '上月': 'Mois dernier',
        '选择支付方式': 'Choisir le mode de paiement',
        '确认支付': 'Confirmer le paiement'
    }
}